import React, { useState } from 'react'
import { Wrapper } from './style'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { PlanTypes } from 'src/redux/types/planTypes'
import { ModalButton } from 'src/components/Global/Button/Button'
import { ModalTitleText, LabelText } from 'src/components/Global/Text/TitleText'
import Select from 'react-select'
import TextField from '@mui/material/TextField'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import {
  ordinalOptions,
  monthOptions,
  dayOptions,
  options,
} from '../createPlans/option'
import { addDays, eachDayOfInterval, format as dateFnsFormat } from 'date-fns'
const TargetFrequency = () => {
  let today = new Date()
  const currentYear = dateFnsFormat(new Date(), 'yyyy')

  const [planData, setPlanData] = useState({
    saving_frequency: '',
    auto_debit_amount: '',
    saving_type: 'automated',
    main_card: 'new',
    saving_date_time: '',
  })
  const currentTime = (value: any) => {
    return dateFnsFormat(new Date(value), 'HH:mm:ss')
  }
  const [monthData, setMonthData] = useState({
    month: '',
    day: '',
    week: '',
  })
  const { auto_debit_amount } = planData

  const handleMonthValue = (options: any) => {
    const newData: any = { ...monthData }
    newData['month'] = options.value
    setMonthData(newData)
  }
  const handleDayValue = (options: any) => {
    const newData: any = { ...monthData }
    newData['day'] = options.value
    setMonthData(newData)
  }
  const handleWeekValue = (options: any) => {
    const newData: any = { ...monthData }
    newData['week'] = options.value
    setMonthData(newData)
  }
  const style = {
    control: (base: any) => ({
      ...base,
      border: 0,
      boxShadow: 'none',
    }),
  }

  const handleOption = (options: any) => {
    planData.saving_frequency = options.value
    dispatch(action(PlanTypes._UPDATE_PLAN_FORM, planData))
    console.log(planData.saving_frequency)
    const newData: any = { ...planData }
    newData['saving_frequency'] = options.value
    setPlanData(newData)
  }
  let location = useLocation()
  const dispatch = useDispatch()

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...planData }
    newData[name] = value
    setPlanData(newData)
    dispatch(action(PlanTypes._UPDATE_PLAN_FORM, newData))
  }
  const nextSavingDay = eachDayOfInterval({
    start: new Date(),
    end: addDays(new Date(), 6),
  })
    .map((_date) => ({
      day: dateFnsFormat(_date, 'EEEE'),
      date: dateFnsFormat(_date, 'yyyy/MM/dd '),
    }))
    .filter((_date) => _date.day === monthData.week)[0]
  const getNextDay = () => {
    let date = addDays(new Date(), 1)
    return dateFnsFormat(date, 'yyyy/MM/dd ')
  }
  const nextPage = (e: any) => {
    let saving_time: any
    if (planData.saving_frequency === 'daily') {
      saving_time = `${getNextDay()} ${currentTime(value)}`
    } else if (planData.saving_frequency === 'weekly') {
      saving_time = `${nextSavingDay.date} ${currentTime(value)}`
    } else if (planData.saving_frequency === 'monthly') {
      saving_time = `${currentYear}/${monthData.month}/${
        monthData.day
      } ${currentTime(value)}`
    }
    if (saving_time === undefined) {
      e.preventDefault()
    } else {
      planData.saving_date_time = saving_time
      dispatch(action(PlanTypes._UPDATE_PLAN_FORM, planData))
    }
  }
  const [value, setValue] = React.useState<Date | null>(null)
  return (
    <Wrapper>
      <div className="pageNumber"></div>
      <form className="content">
        <div className="top-form">
          <ModalTitleText>Savings Frequency</ModalTitleText>
          <p className="desc">How often do you want to save?</p>
          <QuicksaveInput
            type="number"
            name="auto_debit_amount"
            value={auto_debit_amount}
            placeholder="100,000"
            onChange={handleChange}
          />
          <div className="form-group">
            <LabelText>Saving Frequency</LabelText>
            <Select
              placeholder="Frequency Of Savings"
              options={options}
              onChange={handleOption}
              className="filter_select"
              styles={style}
            />
          </div>

          {planData.saving_frequency === 'weekly' && (
            <div className="form-group">
              <LabelText>Select Debit Day</LabelText>
              <Select
                placeholder="Frequency Of Savings"
                options={dayOptions}
                onChange={handleWeekValue}
                className="filter_select"
                styles={style}
              />
            </div>
          )}

          {planData.saving_frequency === 'monthly' && (
            <div>
              <div className="form-group">
                <LabelText>Select Debit Month</LabelText>
                <Select
                  placeholder="Frequency Of Savings"
                  options={monthOptions}
                  onChange={handleMonthValue}
                  className="filter_select"
                  styles={style}
                />
              </div>
              <div className="form-group">
                <LabelText>Select Debit Day</LabelText>
                <Select
                  placeholder="Frequency Of Savings"
                  options={ordinalOptions}
                  onChange={handleDayValue}
                  className="filter_select"
                  styles={style}
                />
              </div>
            </div>
          )}

          <div className="form-group">
            <LabelText>Select Debit Time</LabelText>
            <div className="width">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  value={value}
                  onChange={(newValue) => {
                    setValue(newValue)
                    console.log(value)
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>
          </div>
        </div>
        <div className="form-group-button">
          <Link
            to={`/target-details`}
            state={{ backgroundLocation: location }}
            onClick={nextPage}
          >
            <ModalButton className="button">Continue</ModalButton>
          </Link>
        </div>
      </form>
    </Wrapper>
  )
}

export { TargetFrequency }
